// @ts-check
import axios from "axios";
import { Appsettings } from "../Appsettings";

/**
 *
 * @param {FormData} fd
 */
export async function uploadInformApi(fd) {
  const url = Appsettings.ApiUrl + "/cargarInforme";
  const response = await axios.post(url, fd);
  if (response.status !== 200) {
    throw new Error("Error al subir el informe");
  }
  return response.data;
}

/**
 * @typedef {Object} InformeApiResponse
 * @property {boolean} existe
 * @property {string} nombre
 * @property {number} counter
 * @property {Object[]} list
 */

/**
 * @param {string|number} ID
 * @returns {Promise<InformeApiResponse>}
 */
export async function getInformeByID(ID) {
  //const url = path.join(Appsettings.ApiUrl, `existeinforme`, `${ID}`);
  const url = Appsettings.ApiUrl + "/existeinforme/" + ID;
  const req = await axios.get(url);
  if (req.status !== 200) {
    throw new Error("Error al obtener el informe");
  }
  const res = req.data;
  return res;
}
